export interface LogIdentifiers {
  globalId: string;
  globalSource: string;
}

// Delete when we switch over to Singletons
export enum Category {
  milestone = 'milestone',
  request = 'request',
  security = 'security',
  availability = 'availability',
}

// Delete when we switch over to Singletons
export enum PiiLevelEnum {
  's1' = 's1',
  's2' = 's2',
  'nonPII' = 'non-pii',
}

export class CPLogger {
  static _instances: any;
  static _app: string;

  // no-op; override in child classes
  getInstance(): void {}

  static isRunningInBrowser() {
    return typeof window === 'object' && typeof document === 'object';
  }

  // static generateLogIdentifiers(source?: string) {
  //   return {
  //     globalId: Utils.generateUuid(),
  //     globalSource: source || CPLogger._app || 'Coverpath',
  //   };
  // }
}
